import { createGIF } from "gifshot-plus";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCirclePlay, faCirclePause } from '@fortawesome/free-solid-svg-icons';
import { useState } from "react";

function Gif({ sketches }) {

    const [isPlaying, setIsPlaying] = useState(false);

    const button = isPlaying ? <FontAwesomeIcon icon={faCirclePause} /> : <FontAwesomeIcon icon={faCirclePlay} />

    const handleClick = async () => {

        setIsPlaying(!isPlaying);

        if (!isPlaying) {
            createGIF({
                'images': sketches,
                gifWidth: 640,
                gifHeight: 370,
                frameDuration: 5
            }, function(obj) {
                if (!obj.error) {
                    var image = obj.image,
                    animatedImage = document.getElementById("gif-image");
                    animatedImage.src = image;
                }
            })
        }
        else {
            var image = document.getElementById("gif-image");
            image.src = sketches[0];
        }
    }

    return (
        <div onClick={handleClick} id="gif">
            <img id="gif-image" className={isPlaying ? "playing" : "paused"} src={sketches[0]} width={640} height={370} />
            <div id="play-button" className={isPlaying ? "playing" : "paused"}>{button}</div>
        </div>
    )
}

export default Gif;